import action from 'app/lib/action';
import {VERIFY_UNIT} from '../constants/actionTypes';

export default {
    request : (unit, dom) => action(VERIFY_UNIT.REQUEST)({unit, dom}),
    success : ({ok, dims}) => action(VERIFY_UNIT.SUCCESS)({ok, dims}),
    error   : (error) => action(VERIFY_UNIT.ERROR)({error}),
    reset   : () => action(VERIFY_UNIT.RESET)()
};